var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['emoji', { border: _vm.withBorder }],style:(_vm.styleSize),attrs:{"title":_vm.getEmojiTitle(_vm.emoji)},domProps:{"innerHTML":_vm._s(_vm.emoji.data)}})}
var staticRenderFns = []

export { render, staticRenderFns }